const onSuccess = (position) => {
  console.log('Latitude: '          + position.coords.latitude          + '\n' +
        'Longitude: '         + position.coords.longitude         + '\n' +
        'Altitude: '          + position.coords.altitude          + '\n' +
        'Accuracy: '          + position.coords.accuracy          + '\n' +
        'Altitude Accuracy: ' + position.coords.altitudeAccuracy  + '\n' +
        'Heading: '           + position.coords.heading           + '\n' +
        'Speed: '             + position.coords.speed             + '\n' +
        'Timestamp: '         + position.timestamp                + '\n');
  localStorage.setItem(`latitude`, position.coords.latitude);
  localStorage.setItem(`longitude`, position.coords.longitude);
};

const onError = (error) => {
  console.log(`test error`);
  console.log(error);
  console.log('code: '    + error.code    + '\n' +
        'message: ' + error.message + '\n');
}

document.addEventListener("deviceready", onDeviceReady, false);

function onDeviceReady() {
  console.log(`navigator.geolocation works well`);
  navigator.geolocation.getCurrentPosition(onSuccess, onError);
}